import orderBy from 'lodash/orderBy';
import min from 'lodash/min';
import map from 'lodash/map';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import values from 'lodash/values';
import remove from 'lodash/remove';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import cloneDeep from 'lodash/cloneDeep';
import entries from 'lodash/toPairs';
import memoize from 'lodash/memoize';
import filter from 'lodash/filter';
import each from 'lodash/each';
import concat from 'lodash/concat';
import some from 'lodash/some';
import merge from 'lodash/merge';
import find from 'lodash/find';
import assignIn from 'lodash/assignIn';
import uniqBy from 'lodash/uniqBy';
import indexOf from 'lodash/indexOf';
import first from 'lodash/head';
import sum from 'lodash/sum';
import groupBy from 'lodash/groupBy';
import includes from 'lodash/includes';

const isEmpty = value =>
  value === undefined ||
  value === null ||
  // eslint-disable-next-line use-isnan
  value === NaN ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

export default {
  orderBy,
  min,
  get,
  sortBy,
  remove,
  throttle,
  isEqual,
  values,
  cloneDeep,
  entries,
  memoize,
  filter,
  each,
  map,
  concat,
  some,
  merge,
  find,
  assignIn,
  uniqBy,
  indexOf,
  first,
  isEmpty,
  sum,
  groupBy,
  includes,
};
